import { StageColors } from './banner.model';
import { Stage } from '../../enums';

export const DEFAULT_COLORS: StageColors = { fg: '#20883A', bg: '#ffffff' };

export const STAGE_COLORS: ReadonlyMap<string, StageColors> = new Map<string, StageColors>([
    [Stage.LOCAL, { fg: '#ffffff', bg: '#20883A' }], // Green
    [Stage.DEV, { fg: '#ffffff', bg: '#018484' }], // Teal
    [Stage.QA, { fg: '#000000', bg: '#FBBF28' }], // Amber
    [Stage.TEST, { fg: '#000000', bg: '#1E90FF' }], // DodgerBlue
    [Stage.PROD, { fg: '#ffffff', bg: '#E32B26' }] // Red
]);
